import PropTypes from "prop-types";
import "./Modal.css";
import Tag from "../Tag/Tag";
export const ModalBody = ({
  children,
  isScrollable,
  tagList,
  customHeader,
  title,
  desc,
  ...props
}) => {
  return (
    <>
      <header
        className={
          customHeader
            ? "mn-modal__dialog-header" + "__" + customHeader
            : "mn-modal__dialog-header"
        }
      >
        {title && (
          <div className="mn-modal__dialog-title">
            <div className="title-modal">{title}</div>
            {desc && (
              <>
                <div>
                  <p className="mn-modal__dialog-text">{desc}</p>
                  <div className="mn-modal__dialog-tag">
                    {tagList &&
                      tagList.map((tag, index) => {
                        return (
                          <Tag
                            key={index}
                            mode="outline"
                            size="small"
                            text={tag}
                            type="basic"
                          />
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </header>
      {children && (
        <div
          className="mn-modal__dialog-body"
          data-scrollable={isScrollable}
          {...props}
        >
          {isScrollable ? (
            <div className="mn-modal__dialog-body--scrollable">{children}</div>
          ) : (
            children
          )}
        </div>
      )}
    </>
  );
};

ModalBody.propTypes = {
  isScrollable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  desc: PropTypes.string,
};
